/* eslint-disable import/prefer-default-export */
import { createUrl } from '_clean-code/utils/urlHelper';
import apiClient from '../../api/index';
import {
  GetStopAlertsResponse,
  IStopAlertsService,
  StopAlert
} from './contracts/stopAlerts.service';

export const StopAlertsService: IStopAlertsService = {
  async getStopAlerts(machineIds: number[]): Promise<StopAlert[]> {
    const response = (await apiClient.request(
      'GET',
      createUrl('/v2/stop-alerts').toStringUrl()
    )) as GetStopAlertsResponse;

    const stopAlerts = response.data.map((x) => {
      const item = {
        ...x,
        sentDate: new Date(x.sentDate),
        lastStatus: x.lastStatus || 'new',
        stopStartTime: new Date(x.stopStartTime),
        createdAt: new Date(x.createdAt),
        updatedAt: x.updatedAt && new Date(x.updatedAt),
        acknowledgedDate: x.acknowledgedDate && new Date(x.acknowledgedDate),
        statuses: x.statuses?.map((s) => ({
          ...s,
          createdAt: s.createdAt && new Date(s.createdAt),
          updatedAt: s.updatedAt && new Date(s.updatedAt)
        }))
      };

      const closedStatus = item.statuses?.find((y) => y.status === 'closed');

      if (closedStatus) {
        item.stopEndTime = closedStatus.createdAt;
      }

      return item;
    }) as StopAlert[];

    return stopAlerts.filter((x) => machineIds.includes(x.machineId));
  },
  async updateStatus(id: number, newStatus: string): Promise<void> {
    return apiClient.request(
      'PATCH',
      createUrl(`/v2/stop-alerts/${id}/update-status`, false).toStringUrl(),
      {
        status: newStatus
      }
    );
  }
};
